import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const approveGrammarClipV1DataSchema = z.object({ approved: z.literal(true) });

type ApproveGrammarClipV1DataType = z.infer<typeof approveGrammarClipV1DataSchema>;

export type IApproveGrammarClipV1Response = IAPI<ApproveGrammarClipV1DataType>;

export const approveGrammarClipV1ResponseSchema: z.ZodSchema<IApproveGrammarClipV1Response> =
  createApiResponseSchema(
    approveGrammarClipV1DataSchema,
  ) as z.ZodSchema<IApproveGrammarClipV1Response>;
